import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar metas por empresa
export const listarMetas = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/metas`);
};

// Listar metas por Id
export const listarMeta = async (metaId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/metas/${metaId}`);
};

// Criar meta
export const criarMeta = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/metas/cria-meta`,
    payload
  );
};

// Atualizar meta
export const atualizarMeta = async (
  metaId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/metas/${metaId}/atualiza-meta`,
    payload
  );
};

// Deletar meta
export const deletarMeta = async (
  metaId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/metas/${metaId}/remove-meta`
  );
};

